/*
 * Interface translation.
 *
 * The Russian source string is the key: `t('Профиль')`. That keeps the components readable, means
 * no key has to be invented for the ~500 strings on the site, and makes an untranslated string
 * fall back to Russian rather than to a bare identifier like `nav.profile`.
 *
 * The language is resolved once, at module load. Changing it reloads the page (see SiteHeader),
 * so there is nothing to subscribe to — which matters in an app that has no context or store
 * anywhere. In the russia build getLanguage() is always 'russian' and t() is the identity
 * function, so nothing changes there.
 *
 * Placeholders are positional: t('Нужно {0} звёзд', count).
 */
import { getLanguage } from '../config/region';

import chrome from './dictionaries/chrome';
import account from './dictionaries/account';
import discovery from './dictionaries/discovery';
import play from './dictionaries/play';
import legal from './dictionaries/legal';

const FRAGMENTS = [chrome, account, discovery, play, legal];

const LANGUAGE = getLanguage();

/* One flat lookup for the active language. Fragments are split by area only so that they can be
   written independently; nothing depends on which fragment a string came from. */
const DICTIONARY = LANGUAGE === 'russian'
  ? {}
  : FRAGMENTS.reduce((all, fragment) => Object.assign(all, fragment[LANGUAGE] || {}), {});

export const t = (ru, ...args) => {
  const text = DICTIONARY[ru] || ru;
  if (!args.length) return text;
  return text.replace(/\{(\d+)\}/g, (match, i) => (args[i] === undefined ? match : args[i]));
};

export default t;
